(function () {
    'use strict';

    angular.module("imApp").factory("verticalPurchasingService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3264,
                    parameters: parms || {}
                });
            },
            purchaseItems: function (edit) {
                return $ihttp.post({
                    method: 3337,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
